module.exports = __webpack_public_path__ + "img/health-guide-cancer-mama.d9949ecf.png";